import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as TeamSvg } from '../../assets/team-icon.svg';

export const TeamIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={TeamSvg} {...props} />;
};
